<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Motivo de no facturar</h1>
    <div mat-dialog-content>
        <mat-form-field class="full-width">
            <mat-select formControlName="noBillingReason" placeholder="Motivo de no facturar" required>
                <mat-option *ngFor="let noBillingReason of noBillingReasons" [value]="noBillingReason">
                    {{ noBillingReason.Name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.noBillingReason.errors && f.noBillingReason.errors.required">
                Seleccione un motivo
            </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
            <textarea formControlName="observations" matInput placeholder="Observaciones"></textarea>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>